// extracted by mini-css-extract-plugin
export default {"illustrationAnswerContainer":"IllustrationAnswer__illustrationAnswerContainer___BYepK"};